export default "__VITE_ASSET__CpVOsN23__"